import Icons from 'assets/icons'
import React from 'react'
import {useSelector} from 'react-redux'
import {Link} from 'react-router-dom'

const NotFound = () => {
    const {errorState} = useSelector(state => state.general)
  return (
    <div className='login flex-column gap-3'>
        <h1 className="display-2 text-bold text-muted">
            {errorState.status}
        </h1>
        <div className="display-6">
            {errorState.message}
        </div>
        <Link to='/projects' className='btn-success'> <Icons.backTo/> Anasayfaya Dön</Link>
    </div>
  )
}

export default NotFound